import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { createClient } from "@supabase/supabase-js";
import { onMounted, onUnmounted } from "vue";
import client from "./utils/axios";
import { useUserStore } from "./stores/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let supabase = createClient(
  process.env.VUE_APP_SUPABASE_URL || "",
  process.env.VUE_APP_SUPABASE_API_KEY || ""
);

let userStore = useUserStore();

onMounted(() => {
  supabase
    .channel("admin_translations_events")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "Events",
        filter: `table_name=eq.translations_admin`,
      },
      async () => {
        const adminResponse = await client.get("/admin-translations");
        userStore.setAdminTranslation(adminResponse.data || []);
      }
    )
    .subscribe();

  supabase
    .channel("database_translations_events")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "Events",
        filter: `table_name=eq.translations_database`,
      },
      async () => {
        userStore.setDatabaseTranslationsUpdateTimestamp();
      }
    )
    .subscribe();
});

onUnmounted(() => {
  supabase.removeAllChannels();
});

onMounted(async () => {
  if (userStore) {
    if (userStore.accessToken) {
      const adminResponse = await client.get("/admin-translations");
      userStore.setAdminTranslation(adminResponse.data || []);
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})